import React from 'react';

interface SwitchProps {
    id: string;
    name: string;
    checked?: boolean;
    onChange?: (checked: boolean) => void;
    label?: string;
    disabled?: boolean;
    className?: string;
}

export const Switch: React.FC<SwitchProps> = ({
    id,
    name,
    checked = false,
    onChange,
    label,
    disabled = false,
    className = '',
}) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (onChange) {
            onChange(e.target.checked);
        }
    };

    return (
        <div
            className={`d-flex d-block align-items-center flex-wrap ${className}`}
        >
            <div className="custom-toggle-switch ">
                <input
                    id={id}
                    name={name}
                    type="checkbox"
                    checked={checked}
                    onChange={handleChange}
                    disabled={disabled}
                />
                <label htmlFor={id} className="label-primary">
                    {label}
                </label>
            </div>
        </div>
    );
};

export default Switch;
